<template>
  <div class="p-3 bg-white dark:bg-gray-800">
    <div class="max-w-4xl mx-auto">
      <div class="relative">
        <!-- 文本区域 -->
        <textarea
          ref="textarea"
          v-model="message"
          rows="1"
          placeholder="输入消息..."
          :disabled="disabled"
          class="w-full px-3 py-2 pr-20 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none disabled:opacity-50"
          @input="autoResize"
          @keydown.enter.prevent="handleEnter"
        ></textarea>

        <!-- 按钮组 -->
        <div class="absolute right-2 bottom-2 flex gap-1">
          <!-- 发送按钮 -->
          <button 
            @click="sendMessage"
            class="p-1.5 text-blue-500 hover:text-blue-600 disabled:opacity-50 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
            :disabled="!message.trim() || disabled"
          >
            <svg v-if="!disabled" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
            </svg>
            <svg v-else class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- 提示文本 -->
      <div class="mt-1 text-xs text-gray-400 dark:text-gray-500">
        按 Enter 发送消息，Shift + Enter 换行
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatInput',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: ''
    }
  },
  methods: {
    autoResize() {
      const textarea = this.$refs.textarea
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 'px'
    },
    handleEnter(e) {
      if (e.shiftKey) {
        // Shift + Enter: 换行
        return
      }
      this.sendMessage()
    },
    sendMessage() {
      if (!this.message.trim() || this.disabled) return
      this.$emit('send', this.message)
      this.message = ''
      this.$nextTick(() => {
        this.autoResize()
      })
    },
    setMessage(text) {
      this.message = text
      this.$nextTick(() => {
        this.autoResize()
      })
    }
  }
}
</script> 